import { levels } from '../data/levels'
import type { Level, ScoreBand } from '../types'

export function bandForScore(score: number): ScoreBand {
  if (score >= 70) return 'strong'
  if (score >= 40) return 'attention'
  return 'low'
}

export function bandKey(band: ScoreBand): string {
  return `band.${band}`
}

export function levelForXp(totalXp: number): Level {
  let current = levels[0]
  for (const level of levels) {
    if (totalXp >= level.xp) current = level
  }
  return current
}

export function nextLevel(totalXp: number): Level | null {
  return levels.find((l) => l.xp > totalXp) ?? null
}

export function greetingKey(date = new Date()): string {
  const hour = date.getHours()
  if (hour < 12) return 'home.greeting.morning'
  if (hour < 18) return 'home.greeting.afternoon'
  return 'home.greeting.evening'
}

/**
 * Restrained micro-feedback. Returns at most one message for the current
 * state — never a motivational line on every interaction.
 */
export function feedbackKey(
  dailyXp: number,
  completedCount: number
): string | null {
  if (completedCount === 0) return null
  if (completedCount === 6) return null
  if (completedCount === 5) return 'feedback.one'
  if (dailyXp >= 75) return 'feedback.seventyfive'
  if (dailyXp >= 50) return 'feedback.fifty'
  if (completedCount >= 3) return 'feedback.half'
  return 'feedback.first'
}

/** Weekly Review unlocks Sunday from 18:00. */
export function isWeeklyReviewAvailable(date = new Date()): boolean {
  return date.getDay() === 0 && date.getHours() >= 18
}
